export default {
  clearSocketConnection: () => {
    // socket.off('message-receive');
    // socket.off('team-receive-new-member');
  }
};



// WEBPACK FOOTER //
// src/dialpad/service/globalState.service.js